import { createAction, props } from '@ngrx/store';
import { CoinType } from '../../models/CoinType';

export const loadCoinTypes = createAction('[CoinType] Load CoinTypes');
export const loadCoinTypesSuccess = createAction('[CoinType] Load CoinTypes Success', props<{ coinTypes: CoinType[] }>());
export const loadCoinTypesFailure = createAction('[CoinType] Load CoinTypes Failure', props<{ error: any }>());

export const addCoinType = createAction('[CoinType] Add CoinType', props<{ coinType: CoinType }>());
export const addCoinTypeSuccess = createAction('[CoinType] Add CoinType Success', props<{ coinType: CoinType }>());
export const addCoinTypeFailure = createAction('[CoinType] Add CoinType Failure', props<{ error: any }>());

export const updateCoinType = createAction('[CoinType] Update CoinType', props<{ coinType: CoinType }>());
export const updateCoinTypeSuccess = createAction('[CoinType] Update CoinType Success', props<{ coinType: CoinType }>());
export const updateCoinTypeFailure = createAction('[CoinType] Update CoinType Failure', props<{ error: any }>());

export const deleteCoinType = createAction('[CoinType] Delete CoinType', props<{ id: number }>());
export const deleteCoinTypeSuccess = createAction('[CoinType] Delete CoinType Success', props<{ id: number }>());
export const deleteCoinTypeFailure = createAction('[CoinType] Delete CoinType Failure', props<{ error: any }>());
